import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedPortalRoute = ({ children }) => {
  const isLoggedIn =
    localStorage.getItem("ogfzaPortalLoggedIn") === "true";

  if (!isLoggedIn) {
    return <Navigate to="/portal/login" replace />;
  }

  return children;
};

export default ProtectedPortalRoute;